import React from "react";
import styled from "styled-components";
import placeholderWebp from "./../../../assets/placeholders/pedders_placeholder.webp";
import placeholder from "./../../../assets/placeholders/pedders_placeholder.jpg";

const CheckoutLine = ({ item, currency }) => (
  <Line>
    <Photo>
      {item.item.photos.length ? (
        <img src={item.item.photos[0].url} alt={item.displayname} />
      ) : (
        <picture>
          <source srcSet={placeholderWebp} type="image/webp" />
          <img src={placeholder} alt={item.displayname} />
        </picture>
      )}
    </Photo>
    <Details>
      <div>
        {item.item.description}
        <br />({item.displayname})
      </div>
      <div>Ilość: {item.quantity}</div>
    </Details>
    <Price>
      {item.grosamount} {currency}
    </Price>
  </Line>
);

export default CheckoutLine;

const Line = styled.div`
  font-family: "Open Sans", sans-serif;
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  &:not(:last-of-type) {
    border-bottom: 1px solid #ccc;
  }
`;

const Details = styled.div`
  padding-top: 5px;
  margin-left: 10px;
  color: #666666;
  font-size: 12px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Photo = styled.div`
  width: 80px;

  img {
    width: 100%;
    object-fit: contain;
  }
`;

const Price = styled.div`
  color: #666666;
  font-size: 18px;
  font-weight: 400;
`;
